/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/reducerBlockElementOptions.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for Element Options
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Thursday, September 27, 2018 - 12:12:31 AM (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      09/27/2018  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    ELEMENTOPTION_LIST_CONTAINER_LOADED,
    ELEMENTOPTION_LIST_CONTAINER_UNLOADED,
    ELEMENTOPTION_LIST_TABLE_LOADED,
    ELEMENTOPTION_LIST_TABLE_UNLOADED,

    ELEMENTOPTION_SELECT_ROW,
    ELEMENTOPTION_ADD,
    ELEMENTOPTION_EDIT,
    ELEMENTOPTION_DELETE,
    ELEMENTOPTION_OPEN_WARNING,
    ELEMENTOPTION_CLOSE_WARNING,

    ELEMENTOPTION_EDIT_CONTAINER_LOADED,
    ELEMENTOPTION_EDIT_CONTAINER_UNLOADED,
    ELEMENTOPTION_EDIT_FORM_LOADED,
    ELEMENTOPTION_EDIT_FORM_UNLOADED,
    ELEMENTOPTION_EDIT_DATA_LOAD,
    ELEMENTOPTION_EDIT_CONTAINER_SUBMIT,
    ELEMENTOPTION_EDIT_CONTAINER_CANCEL
} from '../constants/actionTypeBlockElementOptions';

const defaultState = {
    refreshList: false,
    danger: false,
    elementoptionid: 0,
    name: '',
    description: '',
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case ELEMENTOPTION_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                elementoptions: action.payload[0] ? action.payload[0].records : null
            }
        case ELEMENTOPTION_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case ELEMENTOPTION_SELECT_ROW:
            return {
                ...state,
                elementoptionid: action.id
            }
        case ELEMENTOPTION_ADD:
            return {
                ...state
            }
        case ELEMENTOPTION_EDIT:
            return {
                ...state,
                elementoptionid: action.id
            }
        case ELEMENTOPTION_DELETE:
            return {
                ...state,
                elementoptionid: null
            }
        case ELEMENTOPTION_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case ELEMENTOPTION_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case ELEMENTOPTION_EDIT_CONTAINER_LOADED:
        case ELEMENTOPTION_EDIT_DATA_LOAD:
            return {
                ...state,
                elementoptionid: action.payload[0] ? action.payload[0].elementoptionid : 0,
                name: action.payload[0] ? action.payload[0].name : '',
                description: action.payload[0] ? action.payload[0].description : '',
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : ''
            }
        case ELEMENTOPTION_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case ELEMENTOPTION_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case ELEMENTOPTION_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case ELEMENTOPTION_LIST_CONTAINER_UNLOADED:
        case ELEMENTOPTION_LIST_TABLE_UNLOADED:
        case ELEMENTOPTION_EDIT_CONTAINER_UNLOADED:
        case ELEMENTOPTION_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/reducerBlockElementOptions.js